import { useHistory, generatePath } from 'react-router-dom'
import { Button } from 'blaze-ui/Button'
import { useModals } from 'almanac-ui/Modal'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ActivationConnectModal } from 'components/ActivationConnectModal'
import { AUTOPILOT_INTEGRATIONS_PATH } from 'paths'

export const ConnectAccountsButton = () => {
  const history = useHistory()
  const workspaceId = useCurrentWorkspaceId()
  const { openModal, closeModal } = useModals()
  const showIntegrationModal = useFlipperFlag('home_v4')

  const handleConnect = () => {
    if (showIntegrationModal) {
      openModal(ActivationConnectModal, {
        onNavigate: () => {
          closeModal()
        },
      })
    } else {
      closeModal()
      history.push(generatePath(AUTOPILOT_INTEGRATIONS_PATH, { workspaceId }))
    }
  }

  return (
    <Button variant="primary" size="sm" onPress={handleConnect}>
      Connect Accounts
    </Button>
  )
}
